import { forwardRef, type SVGProps } from 'react';

export const AmountCheckErrorIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(function AmountCheckErrorIcon(props, ref) {
  return (
    <svg
      ref={ref}
      fill="none"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1621_11019)">
        <circle cx="24" cy="24" r="22" stroke="currentColor" strokeWidth="4" />
        <g clipPath="url(#clip1_1621_11019)">
          <path
            d="M31.8 30.625H25.2V19.687C25.9658 19.3553 26.5538 18.714 26.8268 17.9254L31.7768 16.283C32.091 16.1787 32.2601 15.8421 32.1548 15.5311L31.7734 14.4052C31.668 14.0943 31.3279 13.9269 31.0136 14.0312L26.5916 15.4981C26.0737 14.6071 25.1134 14 24 14C22.3433 14 21 15.3293 21 16.9688C21 17.096 21.0221 17.2178 21.0379 17.341L16.2233 18.9385C15.909 19.0428 15.7399 19.3794 15.8453 19.6904L16.2266 20.8162C16.332 21.1272 16.6721 21.2946 16.9864 21.1903L22.3132 19.4228C22.4659 19.5256 22.6294 19.6128 22.8004 19.687V32.4062C22.8004 32.7343 23.0689 33 23.4004 33H31.8004C32.1319 33 32.4004 32.7343 32.4004 32.4062V31.2188C32.4 30.8907 32.1315 30.625 31.8 30.625ZM35.9993 25.2812C35.9993 24.6808 36.0495 24.9573 32.8099 18.5455C32.148 17.2359 30.2528 17.2333 29.5898 18.5455C26.3228 25.0122 26.4008 24.6997 26.4008 25.2812H26.4C26.4 26.9207 28.5491 28.25 31.2 28.25C33.8509 28.25 36 26.9207 36 25.2812H35.9993ZM28.5 24.6875L31.2 19.3438L33.9 24.6875H28.5ZM18.4099 23.2955C17.748 21.9859 15.8528 21.9833 15.1898 23.2955C11.9227 29.7622 12.0008 29.4497 12.0008 30.0312H12C12 31.6707 14.1491 33 16.8 33C19.4509 33 21.6 31.6707 21.6 30.0312H21.5993C21.5993 29.4308 21.6495 29.7073 18.4099 23.2955ZM14.1 29.4375L16.8 24.0938L19.5 29.4375H14.1Z"
            fill="currentColor"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1621_11019">
          <rect fill="white" height="48" width="48" />
        </clipPath>
        <clipPath id="clip1_1621_11019">
          <rect
            fill="white"
            height="19"
            transform="translate(12 14)"
            width="24"
          />
        </clipPath>
      </defs>
    </svg>
  );
});
